import React, {useState, useEffect} from 'react';
import { useCompany } from '../../component/CompanySelection/CompanyContext';
import './PaymentStatusTileGroup.css'
import Tile from '../Tile/Tile';
import * as service from '../../service/PaymentStatusTileGroupService';
import { formatAmount, formatTestId, getUrl } from '../../util/EfupUtility';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

export const OPEN_CACHE_KEY = 'openPayments';
export const CLOSE_CACHE_KEY = 'closedPayments';
export const RECON_CACHE_KEY = 'reconciledPayments';
export const PROC_CACHE_KEY = 'processingPayments';

export default function PaymentStatusTileGroup(props) {
    const { companyNumber } = useCompany();
    const {heading, subHeading, paymentType} = props;

    const [isLoading, setIsLoading] = useState(false);
    const [openPayments, setOpenPayments] = useState(window.sessionStorage.getItem(OPEN_CACHE_KEY));
    const [closedPayments, setClosedPayments] = useState(window.sessionStorage.getItem(CLOSE_CACHE_KEY));
    const [reconPayments, setReconPayments] = useState(window.sessionStorage.getItem(RECON_CACHE_KEY));
    const [processPayments, setProcessPayments] = useState(window.sessionStorage.getItem(PROC_CACHE_KEY));

    const testId = formatTestId(heading) + "-label"

    const getPaymentStatus = (company, paymentType) => {
        setIsLoading(true);
        let request = service.RequestParameters(company, paymentType);
        service.makeRequest(request, (response) => {
            window.sessionStorage.setItem(OPEN_CACHE_KEY, response?.totalOutstandingPayments);
            window.sessionStorage.setItem(CLOSE_CACHE_KEY, response?.totalClosedPayments);
            window.sessionStorage.setItem(RECON_CACHE_KEY, response?.totalReconciledPayments);
            window.sessionStorage.setItem(PROC_CACHE_KEY, response?.totalProcessingPayments);

            setPaymentStatusesUsingCache();
            setIsLoading(false);
        });
    };

    useEffect(() => {
        if (!companyNumber || typeof companyNumber === 'undefined') {
            return;
        }

        setPaymentStatusesUsingCache();
        if (openPayments == null || closedPayments == null || reconPayments == null || processPayments == null) {
            getPaymentStatus(companyNumber, paymentType);
        }

    });

    function setPaymentStatusesUsingCache () {
        setOpenPayments(window.sessionStorage.getItem(OPEN_CACHE_KEY));
        setClosedPayments(window.sessionStorage.getItem(CLOSE_CACHE_KEY));
        setReconPayments(window.sessionStorage.getItem(RECON_CACHE_KEY));
        setProcessPayments(window.sessionStorage.getItem(PROC_CACHE_KEY));
    }

    const paymentsLinkForStatus = function(statusCodes) {
        const link = {path: getUrl(companyNumber, '/payments'), state: {search: {statusCodes, lastXdays: 365}}};
        return link;
    };

    const loadingOrValue = function(value, formattedValue, tileId) {
        if (isLoading) {
            return <LoadingSpinner blue testId={`${paymentType}-${tileId}-loading-spinner`}/>;
        }

        if (value === null || typeof value === 'undefined') {
            return '';
        }

        return formattedValue;
    }

    return (
        <>
        <div className="row">
            <div className="col">
                <div className="sectionTitle" data-testid={testId}>{heading} 
                { subHeading && 
                    <span className='sectionSubTitle'> - {subHeading}</span>
                }
            </div>
            </div>
        </div>
        <div className="row dashCards">
            <div className="col">
                <Tile className="dashCardBlue" title="Open Payments" link={paymentsLinkForStatus(['open'])} isLoading={isLoading}>{loadingOrValue(openPayments, formatAmount(openPayments, 0), 'open-payments')}</Tile>
            </div>
            <div className="col">
                <Tile title="Closed Payments" link={paymentsLinkForStatus(['closed'])} isLoading={isLoading}>{loadingOrValue(closedPayments, formatAmount(closedPayments, 0), 'closed-payments')}</Tile>
            </div>
            <div className="col">
                <Tile title="Reconciled Payments" link={paymentsLinkForStatus(['reconciled'])} isLoading={isLoading}>{loadingOrValue(reconPayments, formatAmount(reconPayments, 0), 'reconciled-payments')}</Tile>
            </div>
            <div className="col">
                <Tile className="dashCardRed" title="Processing Payments" link={paymentsLinkForStatus(['processing'])} isLoading={isLoading}>{loadingOrValue(processPayments, formatAmount(processPayments, 0), 'processing-payments')}</Tile>
            </div>
        </div>
        </>
    );
};